import { Card } from '@/shared/components/ui/card'

/** Esqueleto de filas del listado de facturas. */
export function BillingListSkeleton({ rows = 6 }: { rows?: number }) {
  return (
    <div className="divide-y divide-line">
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="flex items-center gap-4 py-3">
          <div className="h-4 w-32 animate-pulse rounded bg-surface" />
          <div className="h-4 w-40 animate-pulse rounded bg-surface" />
          <div className="h-6 w-20 animate-pulse rounded-full bg-surface" />
          <div className="ml-auto h-4 w-24 animate-pulse rounded bg-surface" />
        </div>
      ))}
    </div>
  )
}

/** Esqueleto del detalle de factura. */
export function BillingDetailSkeleton() {
  return (
    <div className="space-y-6">
      <div className="h-5 w-40 animate-pulse rounded bg-surface" />
      <div className="max-w-2xl">
        <Card className="space-y-4">
          <div className="h-28 animate-pulse rounded-xl bg-surface" />
          <div className="space-y-2.5">
            {Array.from({ length: 4 }, (_, i) => (
              <div key={i} className="flex justify-between">
                <div className="h-4 w-48 animate-pulse rounded bg-surface" />
                <div className="h-4 w-20 animate-pulse rounded bg-surface" />
              </div>
            ))}
          </div>
        </Card>
      </div>
    </div>
  )
}
